export const Avatar = {
  defaultProps: { size: 'xl' },
  baseStyle: {
    container: {
      backgroundColor: 'neutral.100',
      color: 'neutral.1200',
    },
    badge: {
      bg: 'brand.primary',
      boxSize: '1rem',
    },
  },
  variants: {
    transparent: {
      container: {
        backgroundColor: 'transparent',
        borderWidth: '3px',
      },
    },
    usercard: {
      container: {
        backgroundColor: 'transparent',
        borderWidth: '3px',
        color: 'white',
        width: '77px',
        height: '77px',
      },
      label: {
        fontSize: '2.25rem',
        fontWeight: '400',
      },
    },
    neutral: {
      container: {
        backgroundColor: 'neutral.100',
      },
      label: {
        color: 'neutral.1100',
      },
    },
    '56x56': {
      container: {
        height: '56px',
        width: '56px',
        fontSize: '12px',
      },
      label: {
        fontSize: '24px',
      },
    },
  },
};
